class FreeShippingMeter extends HTMLElement {
    constructor() {
        super();
    }

    static freeShippingText = window.free_shipping_text.free_shipping_message;
    static freeShippingText1 = window.free_shipping_text.free_shipping_message_1;
    static freeShippingText2 = window.free_shipping_text.free_shipping_message_2;
    static freeShippingText3 = window.free_shipping_text.free_shipping_message_3;
    static freeShippingText4 = window.free_shipping_text.free_shipping_message_4;
    static classLabel1 = 'progress-30';
    static classLabel2 = 'progress-60';
    static classLabel3 = 'progress-100';
    static freeshipPrice = parseInt(window.free_shipping_price);
    static regionalThresholds = [
        {
            prefixes: ['8920', '8921', '8922', '8923'],
            threshold: 79
        }
    ];

    static getRegionalThreshold(cep) {
        const regionalRule = FreeShippingMeter.regionalThresholds.find((rule) =>
            rule.prefixes.some((prefix) => cep.startsWith(prefix))
        );

        return regionalRule?.threshold || FreeShippingMeter.freeshipPrice;
    }

    connectedCallback() {
        this.freeShippingEligible = 0;
        this.progressBar = this.querySelector('[data-shipping-progress]');
        this.messageElement = this.querySelector('[data-shipping-message]');
        this.textEnabled = this.progressBar?.dataset.textEnabled === 'true';
        this.shipVal = window.free_shipping_text.free_shipping_1;
        this.progressMeter = this.querySelector('[data-free-shipping-progress-meter]');

        this.boundOnCartChange = this.onCartChange.bind(this);
        this.boundOnShippingUpdate = this.onShippingUpdate.bind(this);
        this.boundOnShippingRecalculating = () => { this.shippingRecalculating = true; };
        this.boundOnCartUpdate = (event) => this.initialize(event.detail || null);
        this.addEventListener('change', this.boundOnCartChange);
        document.addEventListener('shipping:update', this.boundOnShippingUpdate);
        document.addEventListener('shipping:recalculating', this.boundOnShippingRecalculating);
        document.addEventListener('cart-update', this.boundOnCartUpdate);

        if (!this.cart) this.restoreDrawerProgress();
        // O HTML novo pertence a uma mutação; as tarifas salvas ainda são antigas.
        if (this.closest('#halo-cart-sidebar') && this.closest('.previewCart-wrapper')?.dmCartSnapshot) {
            this.shippingRecalculating = true;
        }

        // O HTML já traz o valor líquido dos produtos. Usa o CEP salvo antes
        // de aguardar a leitura/promessa do carrinho na primeira abertura.
        const initialTotal = Number(this.dataset.cartProductsTotal);
        if (!this.cart && this.closest('#halo-cart-sidebar') &&
            this.hasAttribute('data-cart-products-total') && Number.isFinite(initialTotal)) {
            this.cart = { total_price: initialTotal };
            this.calculateProgress(this.cart);
        }

        this.initialize();
    }

    restoreDrawerProgress() {
        if (!this.closest('#halo-cart-sidebar')) return;
        try {
            const cep = (localStorage.getItem('lastCalculatedCep') || '').replace(/\D/g, '');
            const saved = JSON.parse(sessionStorage.getItem('dmDrawerShippingProgress') || 'null');
            if (!this.getDrawerShippingContext().ready || saved?.cep !== cep ||
                !Number.isFinite(saved.productsTotal) || saved.productsTotal <= 0 ||
                Date.now() - saved.savedAt > 10 * 60 * 1000) return;
            this.cart = { total_price: saved.productsTotal };
            this.calculateProgress(this.cart);
        } catch (error) {
            // Armazenamento indisponível não impede cálculo nem atualização.
        }
    }

    rememberDrawerProgress() {
        if (!this.closest('#halo-cart-sidebar') || !this.cart) return;
        try {
            const cep = (localStorage.getItem('lastCalculatedCep') || '').replace(/\D/g, '');
            if (!this.getDrawerShippingContext().ready) {
                sessionStorage.removeItem('dmDrawerShippingProgress');
                return;
            }
            sessionStorage.setItem('dmDrawerShippingProgress', JSON.stringify({
                cep,
                productsTotal: FreeShippingMeter.getDiscountedProductsTotal(this.cart),
                savedAt: Date.now()
            }));
        } catch (error) {
            // A barra também funciona sem armazenamento de sessão.
        }
    }

    disconnectedCallback() {
        this.removeEventListener('change', this.boundOnCartChange);
        document.removeEventListener('shipping:update', this.boundOnShippingUpdate);
        document.removeEventListener('shipping:recalculating', this.boundOnShippingRecalculating);
        document.removeEventListener('cart-update', this.boundOnCartUpdate);
        window.clearTimeout(this.progressTimer);
        this.cartRequest = (this.cartRequest || 0) + 1;
    }

    initialize(snapshot = this.closest('.previewCart-wrapper')?.dmCartSnapshot) {
        if (snapshot && this.closest('#halo-cart-sidebar')) this.shippingRecalculating = true;
        const request = this.cartRequest = (this.cartRequest || 0) + 1;
        const applyCart = (cart) => {
            if (request !== this.cartRequest || !this.isConnected || !cart) return;
            this.cart = cart;
            this.calculateProgress(cart);
        };

        if (snapshot) {
            // Adição pode fornecer a promessa da leitura já em andamento.
            Promise.resolve(snapshot).then(applyCart).catch(console.error);
        } else {
            Shopify.getCart(applyCart);
        }
    }

    onShippingUpdate(event) {
        // Restaurar/selecionar uma tarifa antiga não conclui a cotação em andamento.
        if (this.shippingRecalculating && !event?.detail?.removed && event?.detail?.source !== 'quote') return;
        this.shippingRecalculating = false;

        if (this.cart) {
            this.calculateProgress(this.cart);
            return;
        }

        this.initialize();
    }

    getDrawerShippingContext() {
        try {
            const cep = (localStorage.getItem('lastCalculatedCep') || '').replace(/\D/g, '');
            const rates = JSON.parse(localStorage.getItem('shippingRates') || '[]');
            const ready = cep.length === 8 && Array.isArray(rates) && rates.length > 0;

            return {
                ready,
                hasDestination: cep.length === 8,
                hasFreeRate: ready && rates.some((rate) => {
                    const price = Number(rate.price);
                    const name = String(rate.name || '').normalize('NFD')
                        .replace(/[\u0300-\u036f]/g, '').trim().toLowerCase();
                    return price === 0 || (price === 0.01 && name === 'frete gratis');
                }),
                threshold: FreeShippingMeter.getRegionalThreshold(cep)
            };
        } catch (error) {
            return {
                ready: false,
                hasDestination: false,
                hasFreeRate: false,
                threshold: FreeShippingMeter.freeshipPrice
            };
        }
    }

    setDrawerShippingState(message) {
        window.clearTimeout(this.progressTimer);
        this.freeShippingEligible = 0;
        this.resetProgressClass('none');
        this.updateMessage(message);
        this.hasRenderedProgress = true;
        this.rememberDrawerProgress();
        this.progressMeter.style.width = '0%';
        this.progressBar.style.setProperty('--free-shipping-progress', '0%');

        const progressBar = this.progressMeter.closest('[role="progressbar"]');
        if (progressBar) progressBar.setAttribute('aria-valuenow', '0');

        const progressText = this.progressMeter.querySelector('.text');
        if (this.textEnabled && progressText) progressText.textContent = '0%';
    }

    static formatThreshold(value) {
        const locale = document.documentElement.lang || 'pt-BR';
        return new Intl.NumberFormat(locale, {
            minimumFractionDigits: 0,
            maximumFractionDigits: 0
        }).format(value);
    }

    static formatDrawerMoney(valueInCents) {
        return new Intl.NumberFormat('pt-BR', {
            style: 'currency',
            currency: 'BRL'
        }).format(valueInCents / 100);
    }

    // items_subtotal_price já inclui descontos de linha. Os descontos de carrinho
    // são deduzidos à parte; total_price pode ter sido somado ao frete pela integração.
    static getDiscountedProductsTotal(cart) {
        if (cart.items_subtotal_price == null && !Array.isArray(cart.items)) {
            return Math.max(0, Number(cart.total_price) || 0);
        }

        const subtotal = Number(cart.items_subtotal_price);
        const productsSubtotal = cart.items_subtotal_price != null && Number.isFinite(subtotal)
            ? subtotal
            : (cart.items || []).reduce((sum, item) => sum + (Number(item.final_line_price) || 0), 0);
        const cartDiscount = (cart.cart_level_discount_applications || []).reduce(
            (sum, discount) => sum + (Number(discount.total_allocated_amount) || 0),
            0
        );

        return Math.max(0, productsSubtotal - cartDiscount);
    }

    onCartChange(e) {
        this.initialize(e.detail || null);
    }

    calculateProgress(cart) {
        const isCartDrawer = Boolean(this.closest('#halo-cart-sidebar'));
        const shippingContext = isCartDrawer
            ? this.getDrawerShippingContext()
            : {
                ready: true,
                hasFreeRate: false,
                threshold: FreeShippingMeter.freeshipPrice
            };
        const freeShippingThreshold = shippingContext.threshold;

        // Só há cotação a aguardar quando existe um CEP válido.
        // Sem destino, atualizações do carrinho devem exibir a orientação imediatamente.
        if (isCartDrawer && !shippingContext.hasDestination) {
            this.shippingRecalculating = false;
        }
        if (this.shippingRecalculating && isCartDrawer) return;

        if (isCartDrawer && !shippingContext.ready) {
            this.setDrawerShippingState('Insira seu CEP para calcular');
            return;
        }

        this.freeShippingEligible = 0;
        let totalPrice = FreeShippingMeter.getDiscountedProductsTotal(cart);
        if ($('body').hasClass('setup_shipping_delivery')) {
            const giftCardItems = $(".cart-item[data-price-gift-card], .previewCartItem[data-price-gift-card]");
            if (giftCardItems.length > 0) {
                giftCardItems.each(function() {
                    totalPrice -= parseFloat($(this).attr("data-price-gift-card"));
                });
            }
        }
        const cartTotalPrice = parseInt(totalPrice) / 100;
        const cartTotalPriceFormatted = cartTotalPrice.toFixed(2);
        const cartTotalPriceRounded = parseFloat(cartTotalPriceFormatted);

        if (isCartDrawer && shippingContext.hasFreeRate && cartTotalPriceRounded >= freeShippingThreshold) {
            this.freeShippingEligible = 1;
            this.setProgressWidthAndText(
                100,
                'Você ganhou <span class="free-shipping-value">frete grátis</span>! 🎉',
                'progress-free'
            );
            return;
        }

        if (isCartDrawer && cartTotalPriceRounded >= freeShippingThreshold) {
            this.setDrawerShippingState('Frete grátis indisponível para este CEP.');
            return;
        }

        let freeShipBar = Math.abs((cartTotalPriceRounded * 100) / freeShippingThreshold);
        if (freeShipBar >= 100) {
            freeShipBar = 100;
        }
        
        const text = this.getText(cartTotalPriceFormatted, freeShipBar, freeShippingThreshold);
        const classLabel = this.getClassLabel(freeShipBar);

        this.setProgressWidthAndText(freeShipBar, text, classLabel);
    }

    getText(cartTotalPrice, freeShipBar, freeShippingThreshold) {
        const isCartDrawer = Boolean(this.closest('#halo-cart-sidebar'));

        if (cartTotalPrice == 0) {
            this.progressBar.classList.add('progress-hidden');
            return isCartDrawer
                ? 'Faltam <span class="free-shipping-value" data-free-shipping-value>' + FreeShippingMeter.formatDrawerMoney(freeShippingThreshold * 100) + '</span> para você ganhar <span class="free-shipping-value">frete grátis</span>.'
                : '<span>' + FreeShippingMeter.freeShippingText + ' ' + FreeShippingMeter.formatThreshold(FreeShippingMeter.freeshipPrice) + '*.</span>';
        }

        this.progressBar.classList.remove('progress-hidden');

        if (cartTotalPrice >= freeShippingThreshold) {
            this.freeShippingEligible = 1;
            return isCartDrawer
                ? 'Você ganhou <span class="free-shipping-value">frete grátis</span>! 🎉'
                : 'Você ganhou <span class="free-shipping-value">frete grátis</span>! 🎉';
        }

        const remainingPrice = Math.abs(freeShippingThreshold - cartTotalPrice);
        this.shipVal = window.free_shipping_text.free_shipping_2;

        if (isCartDrawer) {
            return 'Faltam <span class="free-shipping-value" data-free-shipping-value>' +
                FreeShippingMeter.formatDrawerMoney(Math.round(remainingPrice * 100)) +
                '</span> para você ganhar <span class="free-shipping-value">frete grátis</span>.';
        }

        return '<span>' + FreeShippingMeter.freeShippingText2 + ' </span><span class="free-shipping-value">' +
            FreeShippingMeter.formatDrawerMoney(Math.round(remainingPrice * 100)) +
            '</span><span> ' + FreeShippingMeter.freeShippingText3 + ' </span><span class="text">' +
            FreeShippingMeter.freeShippingText4 + '</span>';
    }

    getClassLabel(freeShipBar) {
        let classLabel;

        if (freeShipBar === 0) {
            classLabel = 'none';
        } else if (freeShipBar <= 30) {
            classLabel = FreeShippingMeter.classLabel1;
        } else  if (freeShipBar <= 60) {
            classLabel = FreeShippingMeter.classLabel2;
        } else if (freeShipBar < 100) {
            classLabel = FreeShippingMeter.classLabel3;
        } else {
            classLabel = 'progress-free'
        }

        return classLabel;
    }
    
    resetProgressClass(classLabel) {
        this.progressBar.classList.remove('progress-30');
        this.progressBar.classList.remove('progress-60');
        this.progressBar.classList.remove('progress-100');
        this.progressBar.classList.remove('progress-free');

        this.progressBar.classList.add(classLabel);
    }
    
    updateMessage(text) {
        const nextMessage = document.createElement('div');
        nextMessage.innerHTML = text;

        const currentValue = this.messageElement.querySelector('[data-free-shipping-value]');
        const nextValue = nextMessage.querySelector('[data-free-shipping-value]');

        if (currentValue && nextValue) {
            currentValue.innerHTML = nextValue.innerHTML;
            return;
        }

        if (this.messageElement.innerHTML.trim() !== text.trim()) {
            this.messageElement.innerHTML = text;
        }
    }

    setProgressWidthAndText(freeShipBar, text, classLabel) {
        this.resetProgressClass(classLabel);
        this.updateMessage(text);

        if ((window.show_multiple_currencies && typeof Currency != 'undefined' && Currency.currentCurrency != shopCurrency) || window.show_auto_currency) {
            Currency.convertAll(window.shop_currency, $('#currencies .active').attr('data-currency'), 'span.money', 'money_format');
        }

        window.clearTimeout(this.progressTimer);
        const applyProgress = () => {
            this.progressMeter.style.width = `${freeShipBar}%`;
            this.progressBar.style.setProperty('--free-shipping-progress', `${freeShipBar}%`);
            const progressBar = this.progressMeter.closest('[role="progressbar"]');
            if (progressBar) progressBar.setAttribute('aria-valuenow', Math.round(freeShipBar));
            if (this.textEnabled) {
                this.progressMeter.querySelector('.text').innerHTML = `${freeShipBar.toFixed(2)}%`;
            }
            this.progressTimer = null;
        };
        // Na nova página, a primeira pintura já deve conter o progresso salvo.
        if (this.closest('#halo-cart-sidebar') && !this.hasRenderedProgress) {
            applyProgress();
        } else {
            this.progressTimer = window.setTimeout(applyProgress, 400);
        }
        this.hasRenderedProgress = true;
        this.rememberDrawerProgress();
    }
}

if (!customElements.get('free-shipping-component')) {
    customElements.define('free-shipping-component', FreeShippingMeter);
}
